import React from "react";
import { Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

function ItemsList({ items, handleDeleteItem, openEditItemModal, categories }) {
  return (
    <div className="MenuList">
      <table>
        <thead>
          <tr>
            <th>S.N.</th>
            <th>Item Name</th>
            <th>Category Name</th>
            <th>Item Pricing</th>
            <th>Status</th>
            <th className="Actionsss">Action</th>
          </tr>
        </thead>
        <tbody>
          {items.length > 0 ? (
            items.map((item, index) => {
              const category = categories.find(
                (cat) => cat.id === item.category
              );

              return (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>
                    <img src={item.docpath} alt={item.name} /> {item.name}
                  </td>
                  <td>{category ? category.category_name : "Unknown"}</td>
                  <td>{item.price}</td>
                  <td
                    style={{
                      color: item.status === "1" ? "green" : "red",
                    }}
                  >
                    {item.status === "1" ? "Active" : "Inactive"}
                  </td>
                  <td className="Actionsss">
                    <Button
                      onClick={() => openEditItemModal(item)}
                      color="primary"
                    >
                      <EditIcon />
                    </Button>
                    <Button
                      onClick={() => handleDeleteItem(item)}
                      color="secondary"
                    >
                      <DeleteIcon />
                    </Button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="6">No items available.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default ItemsList;
